var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"view-button-icon btn icon-link",class:`
	size-${_vm.size}
	type-${_vm.type}
`,attrs:{"href":_vm.href}},[_c('img',{staticClass:"icon",attrs:{"alt":_vm.alt,"src":_vm.imageUrl}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }